<cyno-tabset customClass="tabset tabset--dark">
    <cyno-tab tabTitle="Wel verzekerd" [active]="true">
        <p>
            Uitbreidingen en verbeteringen die u of een vorige bewoner heeft aangebracht aan uw huurhuis of
            koopappartement, zoals:
        </p>
        <list-flat icon="check" [svg]="true">
            <list-flat-item>Betimmeringen, parketvloeren, behang-, schilder-, wit- en metselwerk</list-flat-item>
            <list-flat-item>
                Verwarmings- en airconditioningsinstallaties, sanitaire apparaten, keukenapparatuur en
                beveiligingsinstallaties
            </list-flat-item>
            <list-flat-item>
                Erfafscheidingen, schuttingen, schuren, garages, afdaken, overkappingen, zonnepanelen en
                (schotel)antennes die aan de woning verankerd zijn
            </list-flat-item>
            <list-flat-item>Zonneschermen, rolluiken</list-flat-item>
            <list-flat-item>Laadpalen voor een elektrische auto</list-flat-item>
            <list-flat-item>Tuin</list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat in onze
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Niet verzekerd">
        <list-flat icon="dot" [svg]="true">
            <list-flat-item>Herstellen van huurhuis in oude staat</list-flat-item>
            <list-flat-item>Spullen</list-flat-item>
            <list-flat-item>Schade aan uw woonhuis door:
                <list-flat icon="dot" [svg]="true">
                    <list-flat-item>Normaal gebruik en slijtage</list-flat-item>
                    <list-flat-item>Montage- of installatiefouten</list-flat-item>
                    <list-flat-item>Een fout in het materiaal of de constructie van uw woning</list-flat-item>
                    <list-flat-item>Onvoldoende of slecht onderhoud</list-flat-item>
                    <list-flat-item>Openstaande ramen, deuren, lichtkoepels of luiken</list-flat-item>
                    <list-flat-item>Het kraken van uw woning</list-flat-item>
                    <list-flat-item>Verontreiniging van de bodem, lucht of het water</list-flat-item>
                    <list-flat-item>Verzakking of verschuiven van de grond</list-flat-item>
                </list-flat>
            </list-flat-item>
        </list-flat>
        <!-- prettier-ignore -->
        <p>
            Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
            <ins-pdf-link [pdfLink]="documentsEnum.ConditionsHomeInsurance"
                          pdfLinkTitle="Voorwaarden Woonverzekering">in onze voorwaarden</ins-pdf-link>.
        </p>
    </cyno-tab>
    <cyno-tab tabTitle="Eigen Risico">
        <p>
            Bij onze Inboedelverzekering is het eigen risico standaard €&nbsp;0. Maar in ruil voor een lagere premie kunt u
            kiezen voor een eigen risico van €&nbsp;150. Bij schade door storm is uw eigen risico €&nbsp;200.
        </p>
        <table class="table table--primary">
            <thead>
                <tr>
                    <th></th>
                    <th>Standaard eigen risico</th>
                    <th>Hoger eigen risico (met lagere premie)</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Eigen risico:</td>
                    <td class="table__center">€&nbsp;0</td>
                    <td class="table__center">€&nbsp;150</td>
                </tr>
                <tr>
                    <td>Eigen risico stormschade:</td>
                    <td class="table__center">€&nbsp;200</td>
                    <td class="table__center">€&nbsp;200</td>
                </tr>
            </tbody>
        </table>
    </cyno-tab>
</cyno-tabset>
